import { alpha, Box, Container, Stack } from "@mui/material";
import { CustomImageView } from "../../component/CustomImageView";
import { CustomTextView } from "../../component/CustomTextView";
import { useTranslation } from "react-i18next";
import { CustomButtonView } from "../../component/CustomButtonView";
import { LandingViewModel } from "./LandingViewModel";
import { APP_BG_IMAGE2 } from "../../../data/constant/Constants";
import {
  COLOR_BLACK,
  COLOR_MAIN,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import { LanguageSelectView } from "../home/LanguageSelectView";
import { SchoolTypeToggleGroup } from "../../component/SchoolTypeToggleGroup";
import { provideLoginAnonymouslyUseCase } from "../../di/UseCasesModule";
import wavingChar from "../../../assets/images/characters/daam-c2.png";

export function LandingView() {
  const { t } = useTranslation();
  const viewModel = LandingViewModel(provideLoginAnonymouslyUseCase());
  return (
    <Box
      sx={{
        background: COLOR_MAIN,
        width: "100vw",
        height: "100vh",
        overflowY: "hidden",
        position: "relative",
      }}
    >
      <CustomImageView
        width={"100%"}
        height={"100%"}
        src={APP_BG_IMAGE2}
        props={{ position: "absolute", paddingBottom: "15vh" }}
      />
      <Container maxWidth="md">
        <Stack
          sx={{
            position: "relative",
            height: "100vh",
            alignItems: "center",
            justifyContent: "end",
            zIndex: 2,
            pb: 2,
          }}
        >
          <Stack
            sx={{
              background: alpha(COLOR_WHITE, 0.1),
              backdropFilter: "blur(10px)",
              boxShadow: 12,
              borderRadius: 8,
              padding: 2,
              border: "1px solid white",
              width: "100%",
            }}
            justifyContent={"space-between"}
            minHeight={"30vh"}
          >
            <Stack
              justifyContent={"space-between"}
              height={"100%"}
              width={"100%"}
              direction={"row"}
            >
              <CustomTextView
                variant="h5"
                text={t("welcome_to_trivia_app")}
                textColor="white"
                fontWeight="bold"
              />
              <LanguageSelectView />
            </Stack>

            <CustomImageView
              src={wavingChar}
              width={120}
              height={100}
              scale="contain"
              showLoading={false}
            />
            <Stack gap={2} alignItems={{ xs: "center", sm: "start" }} pt={2}>
              <Stack gap={0.5}>
                <CustomTextView
                  text={t("school_type")}
                  variant="caption"
                  textColor={COLOR_VERY_LIGHT_GRAY}
                />
                <SchoolTypeToggleGroup
                  defaultValue={viewModel.schoolType}
                  onTypeChanged={viewModel.setSchoolType}
                />
              </Stack>
              <Stack width={"100%"}>
                <CustomButtonView
                  text={t("let_get_started")}
                  onClick={viewModel.loginAsGuest}
                  backgroundColor={COLOR_WHITE}
                  textColor={COLOR_BLACK}
                  fontSize="h6"
                  props={{ py: 0.5 }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
